import Icon from 'meinian-package/src/component/icon'
import tianmao from 'image/shopType/tianmao.png'
import { ossImg } from 'meinian-package/src/utils/image'
import HoverImage from '../hoverImage'
import Uninterested from '../cardUninterestedAction'
import styles from './index.module.less'

export default ({ data, style, innerWidth, onUninterested }) => { // 店铺
  const onLinkDetail = () => {
    window.open(`/shopDetail?shopId=${data.shopId}`)
  }
  return <div
    className={styles['intellect-card-shop']}
    style={style}
  >
    <div className="intellect-card-shop-header">
      <Uninterested
        itemId={data.itemId}
        className="intellect-card-shop-uninterested"
        onChange={() => {
          onUninterested(data)
        }}
      />
      <div className="intellect-card-shop-header-left">
        {
          data.logoUrl
            ? <img onClick={onLinkDetail} loading="lazy" className="intellect-card-shop-logo" alt="logo" src={data.logoUrl} />
            : <div onClick={onLinkDetail} className="no-shop-logo" style={{ border: 'solid 1px #f7f7fa', display: 'inline-block' }}>{data.shopName[0]}</div>
      }
      </div>
      <div className="intellect-card-shop-header-right">
        <div className="shop-name" onClick={onLinkDetail} style={{ width: data.isTmall ? 'calc(100% - 36px)' : 'calc(100% - 32px)' }}>
          <div className="name text-overflow">
            {data.shopName}
          </div>
          {
              data.tmallFlag && <img src={tianmao} style={{ width: '16px', height: '16px', marginLeft: '8px' }} />
          }
        </div>
        <div className="shop-tag" onClick={onLinkDetail}>
          {data.shopType ? data.shopType.split('#').map((k) => k && <div className="tag">{k}</div>) : null}
          {data.shopStyle ? data.shopStyle.split('#').map((k) => k && k !== '全覆盖' && <div className="tag">{k}</div>) : null}
          {data.shopType || data.shopStyle ? null : <div className="tag">暂无标签</div>}
        </div>
        <div className="shop-topCategory" onClick={onLinkDetail}>
          <div className="shop-topCategory-label">优势品类：</div>
          <div className="shop-topCategory-value text-overflow" style={{ width: 'calc(100% - 72px)' }}>
            {data?.topCategory}
          </div>
        </div>
      </div>
    </div>
    <div className="images">
      <ListItemImg data={data} innerWidth={innerWidth} />
    </div>
  </div>
}

const ListItemImg = ({ data, innerWidth }) => {
  const count = 4
  const imgWidth = (innerWidth / count) - 14

  const commonItem = (itemList) => {
    return itemList && itemList.map((m, i) => i !== itemList.length - 1 && <a
      href={`/itemDetail/overview?itemId=${m.itemId}`}
      target="blank"
    >
      <HoverImage url={ossImg(m.picUrl, 600, 600)} placement="bottom" wrapStyle={{ width: imgWidth, height: imgWidth }} />
    </a>)
  }
  const allGoods = (itemList, totalItemCount, shopId, url, label = '商品') => {
    return itemList && <a
      className="dimback"
      style={{ width: imgWidth, height: imgWidth }}
      href={`/shopDetail${url || null}?shopId=${shopId}&activeIndex=4`}
      target="_blank"
      rel="noreferrer"
    >
      <img src={ossImg(itemList[itemList.length - 1].picUrl, 600, 600)} className="dim" />
      <span className="all-goods-text">
        <div>
          全部{label}
          <br />
          <span className="df-center-center">
            {totalItemCount}
            <Icon type="m-Vxing_you" className="all-goods-text-icon" />
          </span>
        </div>
      </span>
      </a>
  }
  return (
    <>
      {
            data.topHotItemList && data.topHotItemList.length >= 4
              ? commonItem(data.topHotItemList) : commonItem(data.allItemList)
          }

      {
            data.topHotItemList && data.topHotItemList.length >= 4
              ? allGoods(data.topHotItemList, data.totalItemCount, data.shopId, '/items/hot', '热销') : allGoods(data.allItemList, data.totalItemCount, data.shopId, '/items/all')
          }
    </>
  )
}
